

import React, {Component} from 'react'
import HToolbar from './components/details/HToolbar'
import Items from './components/details/Items'
import Header from './components/details/Header'
import Summary from './components/details/Summary'

var constants = require('../../utils/domain/constants.js');
var saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility.js');

class OrderDetails extends Component 
{
    render()
    {
        return <div className='h-100 w-100 d-flex flex-column justify-content-start'>
                    <div>
                        <Header/>
                    </div>
                    <div className='h-100'>
                        <div className='h-100 w-100 d-flex flex-column justify-content-start'>
                            <div className='h-100' style={{display:'flex', flexDirection:'column', flex:'1 1 0px', overflowY:'auto'}}>
                                <Items/>
                            </div>
                            <div style={{marginTop:'5px', marginBottom:'5px'}}>
                                <Summary/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={{marginBottom:'5px'}}><HToolbar/></div>
                    </div>
                </div>
    }
}

export default OrderDetails